/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferStates = 'Complete' | 'Submitted' | 'Accepted' | 'Declined' | 'Disqualified' | 'Waived' | 'Incomplete';

export const OfferStates = {
    Complete: 'Complete' as OfferStates,
    Submitted: 'Submitted' as OfferStates,
    Accepted: 'Accepted' as OfferStates,
    Declined: 'Declined' as OfferStates,
    Disqualified: 'Disqualified' as OfferStates,
    Waived: 'Waived' as OfferStates,
    Incomplete: 'Incomplete' as OfferStates
};

